import { useContext, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import AppContext from '@/common/context/app.context'
import { parcelDirections } from '@/parcels/constants'

import routes from '../routes.constants'

const ParcelsRedirect = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { info } = useContext(AppContext)
  const allowsOutbound = info?.selectedStore?.preferences?.allows_outbound
  const allowsShipments = info?.selectedStore?.preferences?.allows_shipments

  const showOutbound = allowsOutbound || allowsShipments

  useEffect(() => {
    if (location.pathname !== routes.parcelsPage.index) return

    const getTarget = () => {
      if (!showOutbound) return routes.parcelsPage.inbound

      const storedTab = localStorage.getItem('parcelTab')

      return storedTab === parcelDirections.inbound ? routes.parcelsPage.inbound : routes.parcelsPage.outbound
    }

    navigate(getTarget(), { replace: true })
  }, [location.pathname, showOutbound, navigate])
}

export default ParcelsRedirect
